/**
 * MenuItem.js
 * A menu item component
 *
 * @class   MenuItem
 * @author  Randy Lebeau
 */

import React from 'react';
import ClassNames from 'classnames';
import FontIcon from 'components/font-icon/FontIcon';
import Toggle from 'components/forms/toggle/Toggle';
import LinkMixin from 'mixins/js/LinkMixin';

import Router from 'react-router-component';
const Link = Router.Link;

const Types = {
	LINK: 'LINK',
	SUBHEADER: 'SUBHEADER',
	NESTED: 'NESTED'
};

export default React.createClass({

	mixins: [ LinkMixin ],

	propTypes: {
		index: React.PropTypes.number.isRequired,
		icon: React.PropTypes.string,
		iconClassName: React.PropTypes.string,
		iconRightClassName: React.PropTypes.string,
		attribute: React.PropTypes.string,
		number: React.PropTypes.string,
		data: React.PropTypes.string,
		toggle: React.PropTypes.bool,
		disabled: React.PropTypes.bool,
		onTouchTap: React.PropTypes.func,
		onClick: React.PropTypes.func,
		onToggle: React.PropTypes.func,
		selected: React.PropTypes.bool
	},

	statics: {
		Types: Types
	},

	getDefaultProps() {
		return {
			toggle: false,
			disabled: false,
			href: '',
			target: '_self'
		};
	},

	render() {
		let classes = ClassNames('lui-menu-item', {
			'lui-is-selected': this.props.selected,
			'lui-is-disabled': this.props.disabled
		}),
			iconItem,
			dataItem,
			iconRight,
			attributeItem,
			numberItem,
			toggleItem;

		let {
			to,
			iconClassName,
			iconRightClassName,
			icon,
			number,
			data,
			attribute,
			href,
			target,
			onClick,
			children} = this.props;

		let iconClasses = ClassNames('lui-menu-item-icon', this.props.iconClassName);
		let iconRightClasses = ClassNames('lui-menu-item-icon-right', this.props.iconRightClassName);

		if (this.props.iconClassName || this.props.icon) {
			iconItem = <FontIcon
						magnify={2}
						padding="0px 15px 0px 0px"
						icon={this.props.icon}
						className={iconClasses} />
		}

		if (this.props.iconRightClassName) {
			iconRightItem = <FontIcon
							icon={this.props.icon}
							className={iconRightClasses} />;
		}

		if (this.props.data) {
			let dataItem = <span className="lui-menu-item-data">{data}</span>
		};

		if (this.props.number !== undefined) {
			let numberItem = <span className="lui-menu-item-number">{number}</span>
		};

		if (this.props.attribute !== undefined) 
			{let attributeItem = <span className="lui-menu-item-attribute">{attribute}</span>};

		if (this.props.toggle) {
			let { onToggle } = this.props;
			toggleItem = <Toggle {...this.props} onToggle={this._handleToggle}/>;
		}

		let menuItem = (
			<div
				key={this.props.index}
				className={classes}
				onTouchTap={this._handleTouchTap}
				onClick={this._handleOnClick}>

				{iconItem}
				{children}
				{dataItem}
				{attributeItem}
				{numberItem}
				{toggleItem}
				{iconRight}

			</div>
		);

		return href !== '' ? (
			<Link {...this.props} className="lui-menu-item-link">
				{menuItem}
			</Link>
		) : (
			<li>
				{menuItem}
			</li>
		)
	},

	_openURL(){
		window.open(this.props.href, this.props.target);
	},

	_handleTouchTap(e) {
		if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.index);
	},

	_handleOnClick(e) {
		if (!this.props.disabled && this.props.onClick) this.props.onClick(e, this.props.index);
	},

	_handleToggle(e, toggled) {
		if (!this.props.disabled && this.props.onToggle) this.props.onToggle(e, this.props.index, toggled);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/menu/MenuItem.js
 **/